import { UserPage } from '@components'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/team_/$teamId_/$userId/')({
  component: UserPage,
})
